import {
    WAIT_INIT_ACCOUNT,

    // account manager
    GET_ACCOUNT_MANAGER_DETAIL,
    GET_ACCOUNT_MANAGER_DETAIL_SUCCESS,
    DELETE_ACCOUNT_MANAGER_DETAIL_SUCCESS,
    SAVE_ACCOUNT_MANAGER_DETAIL_SUCCESS,

    // account role
    GET_ACCOUNT_ROLE_LIST,
    GET_ACCOUNT_ROLE_LIST_SUCCESS,
    GET_ACCOUNT_ROLE_DETAIL,
    GET_ACCOUNT_ROLE_DETAIL_SUCCESS,
    DELETE_ACCOUNT_ROLE_DETAIL_SUCCESS,
    SAVE_ACCOUNT_ROLE_DETAIL_SUCCESS,

    GET_SITE_SUCCESS,
    GET_SITE_FAIL,

    GET_NOTIFY_INIT,
    GET_NOTIFY_SUCCESS,
    GET_NOTIFY_FAIL,
    REGET_NOTIFY_INIT,
    REGET_NOTIFY_SUCCESS,
    REGET_NOTIFY_FAIL,
} from "../actions/account/index";

const doAction = (state, action) => {  
    switch (action.type) {

      // account manager      
      case WAIT_INIT_ACCOUNT:
          return {
              ...state,
              errMsg: null,
              status: WAIT_INIT_ACCOUNT,
              popLoading: false
          }
      case GET_ACCOUNT_MANAGER_DETAIL:
          return {
              ...state,
              status: GET_ACCOUNT_MANAGER_DETAIL,
              accountDetail: null
          }
      case GET_ACCOUNT_MANAGER_DETAIL_SUCCESS:
          return {
              ...state,
              status: GET_ACCOUNT_MANAGER_DETAIL_SUCCESS,
              accountDetail: action.params.accountDetail
          }
      case DELETE_ACCOUNT_MANAGER_DETAIL_SUCCESS:
          return {
            ...state,
            status: DELETE_ACCOUNT_MANAGER_DETAIL_SUCCESS,
            errMsg: null
          }
      case SAVE_ACCOUNT_MANAGER_DETAIL_SUCCESS:
          return {
            ...state,
            status: SAVE_ACCOUNT_MANAGER_DETAIL_SUCCESS,
            errMsg: null
          }

      // account role
      case GET_ACCOUNT_ROLE_LIST:
          return {
              ...state,
              status: GET_ACCOUNT_ROLE_LIST,
              roleList: null
          }
      case GET_ACCOUNT_ROLE_LIST_SUCCESS:
          return {
              ...state,
              status: GET_ACCOUNT_ROLE_LIST_SUCCESS,
              roleList: action.params.roleList
          }

      case GET_ACCOUNT_ROLE_DETAIL:
          return {
              ...state,
              status: GET_ACCOUNT_ROLE_DETAIL,
              roleDetail: null
          }
      case GET_ACCOUNT_ROLE_DETAIL_SUCCESS:
          return {
              ...state,
              status: GET_ACCOUNT_ROLE_DETAIL_SUCCESS,
              roleDetail: action.params.roleDetail
          }
      case DELETE_ACCOUNT_ROLE_DETAIL_SUCCESS:
          return {
            ...state,
            status: DELETE_ACCOUNT_ROLE_DETAIL_SUCCESS,
            errMsg: null
          }
      case SAVE_ACCOUNT_ROLE_DETAIL_SUCCESS:
          return {
            ...state,
            status: SAVE_ACCOUNT_ROLE_DETAIL_SUCCESS,
            errMsg: null
          }
      case GET_SITE_SUCCESS:
          return {
            ...state,
            status: GET_SITE_SUCCESS,
            site: action.params.site
          }
      case GET_SITE_FAIL:
          return {
            ...state,
            status: GET_SITE_FAIL,
            site: null
          }
      case GET_NOTIFY_INIT:
          return {
            ...state,
            status: GET_NOTIFY_INIT,
            notifyMsgRecord: null,
            errMsg: null
          }
      case GET_NOTIFY_SUCCESS:
          return {
            ...state,
            status: GET_NOTIFY_SUCCESS,
            notifyMsgRecord: action.params.notifyMsgRecord,
            errMsg: action.params.errMsg
          }
      case GET_NOTIFY_FAIL:
          return {
            ...state,
            status: GET_NOTIFY_FAIL,
            notifyMsgRecord: null,
            errMsg: action.params.errMsg
          }
      case REGET_NOTIFY_INIT:
        return {
          ...state,
          status: REGET_NOTIFY_INIT,
          notifyMsgRecord: null,
          errMsg: null
        }
      case REGET_NOTIFY_SUCCESS:
        return {
          ...state,
          status: REGET_NOTIFY_SUCCESS,
          notifyMsgRecord: action.params.notifyMsgRecord,
          errMsg: action.params.errMsg
        }
      case REGET_NOTIFY_FAIL:
        return {
          ...state,
          status: REGET_NOTIFY_FAIL,
          notifyMsgRecord: null,
          errMsg: action.params.errMsg
        }
      default:
        return state;
      }
  }

const accountReducers = (state = {
    errMsg: null,
    status: WAIT_INIT_ACCOUNT,
    popLoading: false,
    accountDetail: null,
    roleList: null,
    roleDetail: null,
    notifyMsgRecord: null,
  }, action) => {
    switch (action.type) {
      default:
        return doAction(state, action);
    }
  }
  
  export default accountReducers;